import { getFocIncidentRosterTourApi } from '../focIncidentRosterTour/focIncidentRosterTourBridge';
import type { FocCmdTourStepDef } from './focCmdTourSteps';

/** Position workspace registers scroll helpers for FOC 14.x Command staff tours. */
export type FocCmdTourApi = {
  scrollToTour?: (tour: string) => void;
};

let api: Partial<FocCmdTourApi> = {};

export function registerFocCmdTourApi(
  partial: Partial<FocCmdTourApi>
): () => void {
  api = { ...api, ...partial };
  return () => {
    for (const key of Object.keys(partial) as (keyof FocCmdTourApi)[]) {
      if (api[key] === partial[key]) {
        delete api[key];
      }
    }
  };
}

export function getFocCmdTourApi(): Partial<FocCmdTourApi> {
  return api;
}

/**
 * The Liaison tour's demo opens Assign New External User on the embedded roster
 * for this position.
 */
export const FOC_CMD_EXTERNAL_USER_DEMO_POSITION = 'Liaison Officer';

export function prepareFocCmdStep(def: FocCmdTourStepDef | undefined) {
  if (!def) return;
  const roster = getFocIncidentRosterTourApi();
  if (def.rosterAction === 'openAssignExternalUser') {
    roster.openAssignExternalUser?.(FOC_CMD_EXTERNAL_USER_DEMO_POSITION);
  } else {
    roster.closeAddDialogs?.();
  }
  if (!def.tour) return;
  getFocCmdTourApi().scrollToTour?.(def.tour);
}

/** Closes anything a step opened, for when the tour ends. */
export function closeFocCmdTourDialogs() {
  getFocIncidentRosterTourApi().closeAddDialogs?.();
}

export function resetFocCmdTourBridgeForTests() {
  api = {};
}
